export const getFaker = () => import(
    /*
  webpackChunkName: "faker"
  */
    "faker"
).then(i => {
    const faker = i.default;
    // eslint-disable-next-line no-magic-numbers
    faker.seed(123);
    return faker;
});
